export default class EncryptedFile {
    public name!: string;
    public size!: number;
    public ivs: string[] = [];
    public chunks: string[] = [];
}
